module.exports = __webpack_public_path__ + "static/media/25.4faa1f6e.jpg";